module.exports = __webpack_public_path__ + "img/setting.43fe0a58.png";